var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"go-to-login tc"},[_c('img',{staticClass:"photo",attrs:{"src":"/static/mountain.png","alt":"login"}}),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("登录后可查看未读消息")]),_vm._v(" "),_c('mu-flat-button',{staticClass:"btn",attrs:{"label":"登录"},on:{"click":_vm.goToLoginPage}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.5.0@vue-loader/lib/template-compiler?{"id":"data-v-213a4e59","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.5.0@vue-loader/lib/selector.js?type=template&index=0!./src/pages/message/login.vue
// module id = null
// module chunks = 